export function isMobileTerminal() {
    if (typeof window === 'undefined') return false;

    return (
        ('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
        window.matchMedia('(pointer: coarse)').matches
    );
}
